const collections = {
  gem_mining: {
    paths: [
      '/collections/gem-minig',
      '/collections/gem-mining-kits',
    
      '/collections/raw-crystal'
    ],
    tabs: [
      { path: '/collections/gem-minig', label: "All Gem Mining" },
      { path: '/collections/gem-mining-kits', label: "Gem Mining Kits" },
      { path: '/collections/raw-crystal', label: "Raw Crystals" }
    ]
  },
  minerals_fossils: {
    paths: [
      '/collections/minerals-fossils',
      '/collections/crystal-minerals-flat',
      '/collections/mineral-fossil-kits'
    ],
    tabs: [
      { path: '/collections/minerals-fossils', label: "All Minerals & Fossils" },
      { path: '/collections/crystal-minerals-flat', label: "Crystal & Mineral Flats" },
      { path: '/collections/mineral-fossil-kits', label: "Mineral & Fossil Kits" }
    ]
  },
  crystal_jewellery: {
    paths: [
      '/collections/crystal-jewellery',
      '/collections/crystal-bracelets',
      '/collections/8mm-energy-crystal-bracelets',
      '/collections/8mm-energy-crystal-drawstring-bracelets',
      '/collections/crystal-pendants',
      '/collections/crystal-point-pendants',
      '/collections/electroplated-pendants',
      '/collections/star-pendants',
      '/collections/crystal-wire-wrapped-pendants',
      '/collections/tree-of-life-pendants',
      '/collections/crystal-cabochons',
      '/collections/crystal-malas'
    ],
    tabs: [
      { path: '/collections/8mm-energy-crystal-bracelets', label: "All Crystal Jewellery" },
       { path: '/collections/crystal-jewellery', label: "8mm Energy Crystal Bracelets" },
      { path: '/collections/8mm-energy-crystal-drawstring-bracelets', label: "8mm Energy Crystal Drawstring Bracelets" },
      { path: '/collections/crystal-pendants', label: "Crystal Pendants" },
      { path: '/collections/crystal-point-pendants', label: "Crystal Point Pendants" },
      { path: '/collections/electroplated-pendants', label: "Electroplated Pendants" },
      { path: '/collections/star-pendants', label: "Star Pendants" },
      { path: '/collections/crystal-wire-wrapped-pendants', label: "Crystal Wire Wrapped Pendants" },
      { path: '/collections/tree-of-life-pendants', label: "Tree of Life Pendants" },
      { path: '/collections/crystal-cabochons', label: "Crystal Cabochons" },
      { path: '/collections/crystal-malas', label: "Crystal Malas" }
    ]
  },
   crystals_by_name: {
    paths: [
      '/collections/crystal-by-name',
      '/collections/shop-by-popular-stones',
      '/collections/amethyst'
    ],
    tabs: [
      { path: '/collections/crystal-by-name', label: "All Crystals by Name" },
      { path: '/collections/shop-by-popular-stones', label: "Shop by Popular Stones" },
      { path: '/collections/amethyst', label: "Amethyst" }
    ]
  },
  crystals_and_stones: {
    paths: [
      '/collections/crystals-stones',
      '/collections/arrowheads',
      '/collections/chakra-products',
      '/collections/crystal-angels',
      '/collections/crystal-carvings',
      '/collections/crystal-chips',
      '/collections/crystal-chanting-mala',
      '/collections/crystal-eggs',
      '/collections/crystal-figures',
      '/collections/crystal-geometry-platonic-sets',
      '/collections/crystal-hearts',
      '/collections/crystal-kits',
      '/collections/crystal-markabas',
      '/collections/crystal-mineral-flats',
      '/collections/crystal-palm-stones',
      '/collections/dowsing-pendulums',
      '/collections/crystal-pyramids',
      '/collections/crystal-spheres',
      '/collections/crystal-trees',
      '/collections/crystal-towers',
      '/collections/crystal-top-polish-points',
      '/collections/crystal-worry-stones',
      '/collections/polished-tumbled-stones',
      '/collections/raw-crystals',
      '/collections/emf-protection-stones-orgone',
      '/collections/crystal-home-decor',
      '/collections/crystal-on-stands'
    ],
    tabs: [
      { path: '/collections/crystals-stones', label: "All Crystals & Stones" },
      { path: '/collections/arrowheads', label: "Arrowheads" },
      { path: '/collections/chakra-products', label: "Chakra Products" },

      { path: '/collections/crystal-carvings', label: "Crystal Carvings" },
      { path: '/collections/crystal-chips', label: "Crystal Chips" },
      { path: '/collections/crystal-chanting-mala', label: "Crystal Chanting Mala" },
      { path: '/collections/crystal-eggs', label: "Crystal Eggs" },
      { path: '/collections/crystal-figures', label: "Crystal Figures" },
      { path: '/collections/crystal-geometry-platonic-sets', label: "Crystal Geometry/Platonic Sets" },
      { path: '/collections/crystal-hearts', label: "Crystal Hearts" },
      { path: '/collections/crystal-kits', label: "Crystal Kits" },
      { path: '/collections/crystal-markabas', label: "Crystal Markabas" },
      { path: '/collections/crystal-mineral-flats', label: "Crystal & Mineral Flats" },
      { path: '/collections/crystal-palm-stones', label: "Crystal Palm Stones" },
      { path: '/collections/dowsing-pendulums', label: "Dowsing Pendulums" },
      { path: '/collections/crystal-pyramids', label: "Crystal Pyramids" },
      { path: '/collections/crystal-spheres', label: "Crystal Spheres" },
      { path: '/collections/crystal-trees', label: "Crystal Trees" },
      { path: '/collections/crystal-towers', label: "Crystal Towers" },
      { path: '/collections/crystal-top-polish-points', label: "Crystal Top Polish Points" },
      { path: '/collections/crystal-worry-stones', label: "Crystal Worry Stones" },
      { path: '/collections/polished-tumbled-stones', label: "Polished Tumbled Stones" },
      { path: '/collections/raw-crystals', label: "Raw Crystals" },
      { path: '/collections/emf-protection-stones-orgone', label: "EMF Protection Stones & Orgone" },
      { path: '/collections/crystal-home-decor', label: "Crystal Home Decor" },
      { path: '/collections/crystal-on-stands', label: "Crystal on Stands" }
    ]
  }
};

function getCollectionType(url = window.location.href) {
  const currentPath = new URL(url).pathname;
  for (const [key, collection] of Object.entries(collections)) {
    if (collection.paths.includes(currentPath)) {
      return key;
    }
  }
  return null;
}

const collectionType = getCollectionType();

if (collectionType) {
  const currentCollection = collections[collectionType];
  const currentRoute = window.location.pathname;

  const tabsHTML = currentCollection.tabs
    .map((tab, index) => {
      if (tab.path === currentRoute) {
        return `<span class="tab-button active" data-path="${tab.path}" data-index="${index}">${tab.label}</span>`;
      }
      return `<a href="${tab.path}" class="tab-button" data-path="${tab.path}" data-index="${index}">${tab.label}</a>`;
    })
    .join('');

  var tabAppend = `
    <div class="tabs-container">
      <div class="tabs-wrapper container">
        <button class="circle-chevron scroll-button left" id="scrollLeft">
          <svg role="presentation" focusable="false" width="5" height="8" class="icon icon-chevron-left-small reverse-icon" viewBox="0 0 5 8">
            <path d="m4.25 7-3-3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </button>
        <div class="tabs-scroll-container">
          <div class="tabs">
            ${tabsHTML}
          </div>
        </div>
        <button class="circle-chevron scroll-button right" id="scrollRight">
          <svg role="presentation" focusable="false" width="5" height="8" class="icon icon-chevron-right-small reverse-icon" viewBox="0 0 5 8">
            <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </button>
      </div>
    </div>
  `;

  const container = document.querySelector('.collection--section');
  if (container) {
    container.insertAdjacentHTML('afterbegin', tabAppend);
    
    // Initialize scroll functionality after adding the HTML
    const tabsContainer = document.querySelector('.tabs');
    const scrollLeftButton = document.getElementById('scrollLeft');
    const scrollRightButton = document.getElementById('scrollRight');
    const scrollAmount = 200; // Fixed scroll amount

    // Add click handlers for scroll buttons
    if (scrollLeftButton) {
      scrollLeftButton.onclick = () => {
        tabsContainer.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      };
    }

    if (scrollRightButton) {
      scrollRightButton.onclick = () => {
        tabsContainer.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      };
    }

    // Function to check scroll position and update button visibility
    function updateScrollButtons() {
      if (scrollLeftButton && scrollRightButton && tabsContainer) {
        // Show/hide left button based on scroll position
        scrollLeftButton.style.display = tabsContainer.scrollLeft > 0 ? 'flex' : 'none';
        
        // Show/hide right button based on remaining scroll
        const hasMoreToScroll = tabsContainer.scrollWidth > (tabsContainer.scrollLeft + tabsContainer.clientWidth + 1);
        scrollRightButton.style.display = hasMoreToScroll ? 'flex' : 'none';
      }
    }

    // Initial position of active tab
    const activeTab = document.querySelector('.tab-button.active');
    if (activeTab && tabsContainer) {
      const activeTabIndex = parseInt(activeTab.getAttribute('data-index'));
      if (activeTabIndex > 2) {
        const previousTabs = Array.from(tabsContainer.children).slice(0, activeTabIndex);
        const scrollPosition = previousTabs.reduce((acc, tab) => acc + tab.offsetWidth + 10, 0);
        tabsContainer.scrollLeft = scrollPosition;
      }
    }

    // Add scroll event listener to update button visibility
    if (tabsContainer) {
      tabsContainer.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons);
      
      // Initial check for button visibility
      updateScrollButtons();
      
      // Handle tab clicks
      tabsContainer.addEventListener('click', (e) => {
        const tabButton = e.target.closest('.tab-button');
        if (!tabButton || tabButton.classList.contains('active')) return;

        e.preventDefault();
        const path = tabButton.dataset.path;
        
        window.history.pushState({}, '', path);
        document.querySelector('.tab-button.active')?.classList.remove('active');
        tabButton.classList.add('active');
        
        // Position the active tab immediately
        positionActiveTab();
        
        // Then fetch new content
        fetchCollectionContent(path);
      });

      // Center tabs if less than 7
      const tabCount = tabsContainer.children.length;
      if (tabCount < 7) {
        tabsContainer.style.justifyContent = 'center';
      }
    }
  }

  // Function to position active tab
  function positionActiveTab() {
    const tabsContainer = document.querySelector('.tabs');
    const activeTab = document.querySelector('.tab-button.active');
    
    if (!activeTab || !tabsContainer) return;
    
    // Get active tab index
    const activeTabIndex = parseInt(activeTab.getAttribute('data-index'));
    
    // Calculate scroll position if active tab is not at the start
    if (activeTabIndex > 2) {
      const previousTabs = Array.from(tabsContainer.children).slice(0, activeTabIndex);
      const scrollPosition = previousTabs.reduce((acc, tab) => acc + tab.offsetWidth + 10, 0);
      
      // Set scroll position without animation
      tabsContainer.style.scrollBehavior = 'auto';
      tabsContainer.scrollLeft = scrollPosition;
      
      // Reset scroll behavior
      setTimeout(() => {
        tabsContainer.style.scrollBehavior = 'smooth';
      }, 50);
    } else {
      tabsContainer.scrollLeft = 0;
    }
    
    // Update scroll buttons visibility
    updateScrollButtons();
  }

  // Function to fetch new collection content
  async function fetchCollectionContent(path) {
    try {
      const response = await fetch(path);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newContent = doc.querySelector('.collection--section');
      if (newContent) {
        const existingTabs = document.querySelector('.tabs-container');
        container.innerHTML = '';
        container.appendChild(existingTabs);
        
        Array.from(newContent.children).forEach(child => {
          if (!child.classList.contains('tabs-container')) {
            container.appendChild(child.cloneNode(true));
          }
        });
        
        // Position active tab after content update
        positionActiveTab();
      }
    } catch (error) {
      console.error('Error fetching collection content:', error);
      window.location.href = path;
    }
  }

  // Handle browser back/forward buttons
  window.addEventListener('popstate', () => {
    const newPath = window.location.pathname;
    const newActiveTab = document.querySelector(`[data-path="${newPath}"]`);
    if (newActiveTab) {
      document.querySelector('.tab-button.active')?.classList.remove('active');
      newActiveTab.classList.add('active');
      fetchCollectionContent(newPath);
    }
  });
}